import { render } from "./TaskEditorTriggers.vue?vue&type=template&id=39a716a4"
import script from "./TaskEditorTriggers.vue?vue&type=script&lang=js"
export * from "./TaskEditorTriggers.vue?vue&type=script&lang=js"

import "./TaskEditorTriggers.vue?vue&type=style&index=0&id=39a716a4&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__